import React from 'react';

interface TickIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  color?: string;
}

/**
 * TickIcon Component
 * 
 * A checkmark/tick icon used for indicating success or presence.
 * 
 * @component
 * @example
 * ```tsx
 * <TickIcon size={16} color="#10b981" />
 * ```
 */
export const TickIcon: React.FC<TickIconProps> = ({ 
  size = 16, 
  color = '#10b981',
  ...props 
}) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    fill="none" 
    viewBox="0 0 16 16"
    {...props}
  >
    <path 
      stroke={color} 
      strokeLinecap="round" 
      strokeLinejoin="round" 
      strokeWidth={2} 
      d="M13.333 4L6 11.333 2.667 8"
    />
  </svg>
);

export default TickIcon;

